import scenceTypes from './types/scence'
import scenceService from '@/api/scence'

const state = {}

const actions = {
  /**
   * 防治区查询
   */
  [scenceTypes.GET_PREVENTION_AREAINFO] ({ commit }, { aDCD = '', pageIndex = '', pageSize = '' }) {
    return new Promise((resolve, reject) => {
      scenceService.getPreventionAreaInfo({ aDCD, pageIndex, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 新建/编辑保存防治区信息
   */
  [scenceTypes.SAVE_PREVENTION_AREAINFO] (_, preventGroup) {
    return new Promise((resolve, reject) => {
      scenceService.savePreventionAreaInfo(preventGroup).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 删除防治区信息
   */
  [scenceTypes.DELETE_PREVENTION_AREAINFO] (_, { id }) {
    return new Promise((resolve, reject) => {
      scenceService.deletePreventionAreaInfo(id).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 历史山洪灾害调查情况操作
   */
  [scenceTypes.GET_FLOODINFO] ({ commit }, { distPlace = '', pageIndex = '', pageSize = '' }) {
    return new Promise((resolve, reject) => {
      scenceService.getFloodInfo({ distPlace, pageIndex, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 新建/编辑历史山洪灾害调查情况
   */
  [scenceTypes.SAVE_FLOODINFO] (_, preventGroup) {
    return new Promise((resolve, reject) => {
      scenceService.saveFloodInfo(preventGroup).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 删除历史山洪灾害调查情况
   */
  [scenceTypes.DELETE_FLOODINFO] (_, { id }) {
    return new Promise((resolve, reject) => {
      scenceService.deleteFloodInfo(id).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 水库
   */
  [scenceTypes.GET_RESERVOIR] ({ commit }, { adcd = '', cacd = '', stationId = '', reservoirScale = '', searchName = '', pageIndex = '', pageSize = '', stcd = '' }) {
    return new Promise((resolve, reject) => {
      scenceService.getReservoir({ adcd, cacd, stationId, reservoirScale, searchName, pageIndex, pageSize, stcd }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 新建/编辑水库数据
   */
  [scenceTypes.SAVE_RESERVOIR] (_, preventGroup) {
    return new Promise((resolve, reject) => {
      scenceService.saveReservoir(preventGroup).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 删除水库数据
   */
  [scenceTypes.DELETE_RESERVOIR] (_, { id }) {
    return new Promise((resolve, reject) => {
      scenceService.deleteReservoir(id).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 水闸
   */
  [scenceTypes.GET_SLUICE] ({ commit }, { adcd = '', cacd = '', sluiceType = '', searchName = '', pageIndex = '', pageSize = '' }) {
    return new Promise((resolve, reject) => {
      scenceService.getSluice({ adcd, cacd, sluiceType, searchName, pageIndex, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 新建/编辑水闸数据
   */
  [scenceTypes.SAVE_SLUICE] (_, preventGroup) {
    return new Promise((resolve, reject) => {
      scenceService.saveSluice(preventGroup).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 删除水闸数据
   */
  [scenceTypes.DELETE_SLUICE] (_, { id }) {
    return new Promise((resolve, reject) => {
      scenceService.deleteSluice(id).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 堤防
   */
  [scenceTypes.GET_DIKE] ({ commit }, { aDCD = '', cACD = '', searchName = '', pageIndex = '', pageSize = '' }) {
    return new Promise((resolve, reject) => {
      scenceService.getDike({ aDCD, cACD, searchName, pageIndex, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 新建/编辑堤防数据
   */
  [scenceTypes.SAVE_DIKE] (_, preventGroup) {
    return new Promise((resolve, reject) => {
      scenceService.saveDike(preventGroup).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 删除堤防数据
   */
  [scenceTypes.DELETE_DIKE] (_, { id }) {
    return new Promise((resolve, reject) => {
      scenceService.deleteDike(id).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 塘堰坝
   */
  [scenceTypes.GET_DAM] ({ commit }, { aDCD = '', cACD = '', searchName = '', pageIndex = '', pageSize = '' }) {
    return new Promise((resolve, reject) => {
      scenceService.getDam({ aDCD, cACD, searchName, pageIndex, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 新建/编辑塘堰坝数据
   */
  [scenceTypes.SAVE_DAM] (_, preventGroup) {
    return new Promise((resolve, reject) => {
      scenceService.saveDam(preventGroup).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 删除塘堰坝数据
   */
  [scenceTypes.DELETE_DAM] (_, { id }) {
    return new Promise((resolve, reject) => {
      scenceService.deleteDam(id).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 简易水位/雨量站
   */
  [scenceTypes.GET_SIMPLERAIN_ANDWATER] ({ commit }, { aDCD = '', pageIndex = '', pageSize = '' }) {
    return new Promise((resolve, reject) => {
      scenceService.getSimpleRainAndWater({ aDCD, pageIndex, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 新建/编辑水位/雨量站数据
   */
  [scenceTypes.SAVE_SIMPLERAIN_ANDWATER] (_, preventGroup) {
    return new Promise((resolve, reject) => {
      scenceService.saveSimpleRainAndWater(preventGroup).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 删除水位/雨量站数据
   */
  [scenceTypes.DELETE_SIMPLERAIN_ANDWATER] (_, { id }) {
    return new Promise((resolve, reject) => {
      scenceService.deleteSimpleRainAndWater(id).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 自动遥测站
   */
  [scenceTypes.GET_STATIONINFO] ({ commit }, { aDCD = '', sID = '22', sttp = '', searchName = '', pageIndex = '', pageSize = '' }) {
    return new Promise((resolve, reject) => {
      scenceService.getStationInfo({ aDCD, sID, sttp, searchName, pageIndex, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 保存自动遥测站
   */
  [scenceTypes.SAVE_STATIONINFO] (_, stationGroup) {
    return new Promise((resolve, reject) => {
      scenceService.saveStationInfo(stationGroup).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 导出自动遥测站
   */
  [scenceTypes.EXPORT_STATIONINFO] ({ commit }, stationGroup) {
    return new Promise((resolve, reject) => {
      scenceService.exportStationInfo(stationGroup).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 删除自动遥测站
   */
  [scenceTypes.DELETE_STATIONINFO] (_, { id }) {
    return new Promise((resolve, reject) => {
      scenceService.deleteStationInfo(id).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   *  获取所有测站
   */
  [scenceTypes.GET_SITE_ALL] ({ commit }) {
    return new Promise((resolve, reject) => {
      scenceService.getSiteFindAllList().then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   *  获取主要测站
   */
  [scenceTypes.GET_SITE_MAIN] ({ commit }) {
    return new Promise((resolve, reject) => {
      scenceService.getSiteFindMainList().then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 预案信息
   */
  [scenceTypes.GET_PLAN] ({ commit }, { aDCD = '', searchName = '', pageIndex = '', pageSize = '' }) {
    return new Promise((resolve, reject) => {
      scenceService.getPlan({ aDCD, searchName, pageIndex, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 保存预案信息
   */
  [scenceTypes.SAVE_PLAN] (_, stationGroup) {
    return new Promise((resolve, reject) => {
      scenceService.savePlan(stationGroup).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 删除预案信息
   */
  [scenceTypes.DELETE_PLAN] (_, { id }) {
    return new Promise((resolve, reject) => {
      scenceService.deletePlan(id).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 预警指标信息
   */
  [scenceTypes.GET_WARNINDEX] ({ commit }, { stationName = '', villageName = '', aDCD = '', pageIndex = '', pageSize = '' }) {
    return new Promise((resolve, reject) => {
      scenceService.getWarnIndex({ stationName, villageName, aDCD, pageIndex, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 保存预警指标信息
   */
  [scenceTypes.SAVE_WARNINDEX] (_, stationGroup) {
    return new Promise((resolve, reject) => {
      scenceService.saveWarnIndex(stationGroup).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 删除预警指标信息
   */
  [scenceTypes.DELETE_WARNINDEX] (_, { relationeId }) {
    return new Promise((resolve, reject) => {
      scenceService.deleteWarnIndex(relationeId).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 行政区划三级联动接口
   */
  [scenceTypes.GET_MUTIRANKS_ADCD] ({ commit }, { parentAdcdCode = '' }) {
    return new Promise((resolve, reject) => {
      scenceService.getMutiRanksAdcd({ parentAdcdCode }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 行政区划基本信息
   */
  [scenceTypes.getAdcdBaseInfo] ({ commit }, { townAdcdCode = '' }) {
    return new Promise((resolve, reject) => {
      scenceService.getAdcdBaseInfo({ townAdcdCode }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 行政区划
   */
  [scenceTypes.getAdcd] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      scenceService.getAdcd(params).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 行政区划 新增
   */
  [scenceTypes.upAdcd] (_, params) {
    return new Promise((resolve, reject) => {
      scenceService.upAdcd(params).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 行政区划 删除
   */
  [scenceTypes.delAdcd] (_, { id }) {
    return new Promise((resolve, reject) => {
      scenceService.delAdcd(id).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 库容曲线
  /**
   * 获取库容曲线测站
   */
  [scenceTypes.GET_STORAGE_CURVE_STATION] (_, params) {
    return new Promise((resolve, reject) => {
      scenceService.getStorageCurveStation(params).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 水库库容曲线获取
   */
  [scenceTypes.GET_STORAGE_CURVE] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      scenceService.getStorageCurve(params).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 保存水库库容曲线
   */
  [scenceTypes.SAVE_STORAGE_CURVE] (_, params) {
    return new Promise((resolve, reject) => {
      scenceService.saveStorageCurve(params).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  }
}

const mutations = {}

export default {
  state,
  actions,
  mutations
}
